module.exports = __webpack_public_path__ + "static/media/11.f6ef3e9a.jpg";